import { CaretDownIcon } from "@radix-ui/react-icons";
import * as Collapsible from "@radix-ui/react-collapsible";
import { Box, Button, Flex, Text } from "@radix-ui/themes";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import _, { compact } from "lodash";
import { t } from "i18next";
import { Checkbox } from "../../ui/Checkbox/Checkbox";
import { ColumnFiltersState } from "@tanstack/react-table";
import { AccordionContent, AccordionItem, AccordionTrigger } from "../../ui/Accordion";
import { ScrollArea } from "../../ui/ScrollArea/ScrollArea";
import { SelectOption } from "../../types/types";
import { TbSquare, TbSquareCheckFilled } from "react-icons/tb";

type Props = {
  filterState: [ColumnFiltersState, Function];
  content: Array<SelectOption>;
  categoryName: string;
  columnId: string;
  searchbar?: boolean;
};

const Category = ({ filterState, content, categoryName, columnId, searchbar = false }: Props) => {
  const [open, setOpen] = React.useState(false);
  const [filters, setFilter] = filterState;
  const [search, setSearch] = React.useState("");

  const filter = filters.find((filter) => filter.id == columnId)?.value as string[];

  const changeFilter = (checked: boolean | "indeterminate", newFilter: string) => {
    let currentSubFilter: string[];
    let isEmpty = false;
    if (!checked) {
      currentSubFilter = _.without(filter, newFilter);
    } else {
      if (filter) currentSubFilter = _.concat(filter, newFilter);
      else currentSubFilter = [newFilter];
    }
    if (currentSubFilter.length == 0) isEmpty = true;
    setFilter(columnId, currentSubFilter, isEmpty);
  };
  

  // Поиск
  const preData = compact(content); // Очистка от "ложных" данных (null, 0, false, '')
  let data = preData.filter((item) => item.label.toLowerCase().includes(search.toLowerCase()));

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  return (
    content.length > 1 ?
    <AccordionItem value={categoryName}>
      <AccordionTrigger className="h-8 px-3 space-x-2">
        <div className="flex w-full justify-between">
          <span>{t(categoryName)}</span>
          <span>{filter && filter.length}</span>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        {searchbar && (
          <label htmlFor="search">
            <input
              id="search"
              type="text"
              placeholder={t("search")}
              autoComplete="off"
              size={30}
              value={search}
              onChange={handleSearch}
            />
          </label>
        )}
        <ScrollArea className={`h-[${data.length * 20 > 300 ? 300 : data.length * 20}px] bg-muted py-2`}>
        <div className="flex flex-col space-y-1 px-1">
          {data.map((option, idx) => {
            return (
              <div key={idx} className="flex items-center justify-between w-full pl-2 pr-1 py-1 rounded cursor-pointer hover:bg-primary hover:text-white overflow-hidden" onClick={() => changeFilter(!(filter ? (filter.includes(option.value) ? true : false) : false),  option.value)}>
                  <div className="truncate max-w-[200px]">{option.label}</div>
                  {filter ? (filter.includes(option.value) ? <TbSquareCheckFilled size={18} className="w-6 hover:text-white"/> : <TbSquare size={18} className="w-6 hover:text-white"/>) : <TbSquare size={18} className="w-6 hover:text-white"/>}
              </div>
            );
          })}
        </div>
        </ScrollArea>
      </AccordionContent>
    </AccordionItem>
    :
    <></>
  );
};

export default Category;
